// src/lib/registerSW.ts
//
// Enregistrement du service worker PWA (cf. public/sw.js).
// Stratégie :
// - Production uniquement (jamais en dev — éviterait les frustrations de cache)
// - Soft update : à chaque visite, vérifie une nouvelle version dispo
// - Si nouvelle version : recharge silencieusement en arrière-plan
//
// Cf. https://web.dev/articles/service-workers-registration

export function registerServiceWorker(): void {
  // Ne pas activer en dev (Vite HMR + SW cache = enfer)
  if (import.meta.env.DEV) return;

  // Vérifier que le navigateur supporte les service workers
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  // S'enregistrer après le load pour ne pas concurrencer le rendu initial
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        // Force la vérification d'update à chaque chargement
        registration.update();

        // Si une nouvelle version est installée et en attente, la déclencher
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        // Écoute des updates entrantes
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nouvelle version prête : la déclencher
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[SW] registration failed:', err);
      });

    // Quand le SW prend le contrôle (nouvelle version active), recharge la page
    // une seule fois pour montrer la version fraîche
    let reloadOnce = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadOnce) return;
      reloadOnce = true;
      window.location.reload();
    });
  });
}
